import AppConfig from '../appConfig';
import AbstractFetch from './AbstractFetch';

class LaunchDarklyFetch extends AbstractFetch {
  /**
   * Generic error handler for Fetch calls, throws an error if the Fetch call returned anythong other than a 200
   *
   * @param response
   * @returns {*}
   */
  static handleErrors(response) {
    if (response.ok) {
      return response;
    }
    console.log('ERROR: ' + response.status);
    throw Error(response.status);
  }

  static getLaunchDarklyVariation(flag) {
    return AbstractFetch.fetch(AppConfig.apiUrl + '/ld-variation?flag=' + flag, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(LaunchDarklyFetch.handleErrors)
      .then((response) => response.json());
  }
}

export default LaunchDarklyFetch;
